/* eslint-disable react/no-danger */
import { useEffect } from "react";
import parse from "html-react-parser";

export default function FareFinderDT(props) {
  useEffect(() => {
    if (language && language === "ar") document.body.classList.add("isArabic");
  });

  const { language, main_div: mainDiv, initial_js: initialJS = "", top_overlay } = props?.data || {};;

  return (
    <>
      {initialJS && initialJS !== "" ? parse(initialJS) : null}
      <div dangerouslySetInnerHTML={{ __html: mainDiv }} />
      <div dangerouslySetInnerHTML={{ __html: top_overlay }} />
    </>
  );
};
